import { useQuery } from '@tanstack/react-query';
import { type secretNames } from '../../constants/constants';
import { ApiEndpoints } from '../../constants/api-constants';
import { apiClient } from '../../services/ApiClient';
import { Queries, QueryCacheConfig } from '../../constants/query-constants';

type SecretName = (typeof secretNames)[keyof typeof secretNames];

export const useFetchSecret = (secretName: SecretName): string => {
  const getSecret = async (): Promise<string> => {
    return apiClient.get<string>(ApiEndpoints.getSecrets(secretName));
  };

  const result = useQuery<string, Error>({
    ...QueryCacheConfig[Queries.Secret],
    queryKey: [Queries.Secret, secretName],
    queryFn: getSecret,
  });

  return result.data;
};
